import type { UserSummary } from './types.js';

export function StatusBadges({ user }: { user: UserSummary }) {
  return (
    <>
      {user.status === 'invited' && <span className="badge b-soon">Invited</span>}
      {user.status === 'deactivated' && <span className="badge b-off">Deactivated</span>}
      {user.locked && <span className="badge b-hot">Locked</span>}
      {user.status === 'active' && !user.appSetUp && (
        <span className="badge b-soon">App not set up</span>
      )}
    </>
  );
}
